import {combineReducers} from '@reduxjs/toolkit';
import {adminRightsReducer} from 'src/admin-rights-service';
import {criteriaStripSlice} from 'src/components/criteria-strip';
import {dataTableSelectionSlice} from 'src/components/data-table-selection';
import {accessRightsSlice} from 'src/hooks/access-rights/services/access-rights-slice';
import {systemAccountsSlice} from 'src/hooks/account/system-accounts';
// Remove this legacy import after the Account_Provisioning_History release.
import {accountActiveUserHistoryEventsSlice} from 'src/hooks/account-active-user-history-events';
import {deprecatedAccessModulesSlice} from 'src/hooks/deprecatedAccessModules/services/deprecated-access-modules-slice';
import {dictionarySlice} from 'src/hooks/dictionaries/services/dictionary-slice';
import {recentlyViewedSlice} from 'src/hooks/recently-viewed/services/recently-viewed-slice';
import {accountSearchResultReducer} from 'src/modules/account-search-result';
import {createAddAttendeesReducer} from 'src/modules/bulk-update/add-attendees/services/add-attendees.reducer';
import {bulkUpdateResultReducer} from 'src/modules/bulk-update/bulk-update-result-reducer';
import {configReducer} from 'src/modules/config';
import {createUsersReducer} from 'src/modules/create-user';
import {entitlementDrawerSlice} from 'src/modules/entitlements';
import {internalNotificationsReducer} from 'src/modules/internal-notification';
import {userInfoSlice} from 'src/modules/main/services/user-info-slice';
import {manageEntitlementsReducer} from 'src/modules/manage-entitlements';
import {platformAlertBuilderReducer} from 'src/modules/platform-alert-builder';
import {accountPageReducer} from 'src/modules/profile/account/services/account-page-reducer';
import {rootReducer as apiv2} from 'src/modules/profile/account/tabs/admin-account-api-v2/services/reducers';
import {userPageReducer} from 'src/modules/profile/user/services/user-page-reducer';
import {ssoAccountsReducer} from 'src/modules/sso-accounts';
import {userSearchResultReducer} from 'src/modules/user-search-result';

export const rootReducer = combineReducers({
    // Remove this legacy reducer after the Account_Provisioning_History release.
    accountActiveUserHistoryEvents: accountActiveUserHistoryEventsSlice.reducer,
    accessRights: accessRightsSlice.reducer,
    accountPage: accountPageReducer,
    adminRights: adminRightsReducer,
    apiv2,
    bulkUpdateResult: bulkUpdateResultReducer,
    config: configReducer,
    criteriaStrip: criteriaStripSlice.reducer,
    createUsers: createUsersReducer,
    addAttendees: createAddAttendeesReducer,
    deprecatedAccessModules: deprecatedAccessModulesSlice.reducer,
    dictionaries: dictionarySlice.reducer,
    entitlementDrawer: entitlementDrawerSlice.reducer,
    internalNotification: internalNotificationsReducer,

    manageEntitlements: manageEntitlementsReducer,
    platformAlertBuilder: platformAlertBuilderReducer,
    recentlyViewed: recentlyViewedSlice.reducer,
    ssoAccounts: ssoAccountsReducer,
    accountSearchResult: accountSearchResultReducer,
    userSearchResult: userSearchResultReducer,
    selection: dataTableSelectionSlice.reducer,
    systemAccounts: systemAccountsSlice.reducer,
    userInfo: userInfoSlice.reducer,
    userPage: userPageReducer,
});
